import { Stack } from '@mantine/core';
import {
  FormulaUpdateModal,
  PageContainer,
  PageHeader,
} from '../../../shared_components';
import { GoalsWidget } from './goalsWidget';
import { GoalTrackerWidget } from './goalTrackerWidget';
import { PrevMeasurementsList } from './prevMeasurementsList';
import { useUserDataStore } from '../../../shared_stores';
import { useTranslation } from 'react-i18next';

export const Dashboard = () => {
  const userDataStore = useUserDataStore();
  const { t } = useTranslation('reports');

  const greeting = userDataStore.userInfo?.nickName
    ? `, ${userDataStore.userInfo?.nickName}`
    : `!`;

  return (
    <PageContainer>
      <FormulaUpdateModal />
      <PageHeader lowMargin title={t('reports:hello') + greeting} />
      <Stack>
        {userDataStore.userGoal && <GoalsWidget />}
        <GoalTrackerWidget />
        <PrevMeasurementsList />
      </Stack>
    </PageContainer>
  );
};
